<!-- 
  キャンバスに乗るイメージアイテム
-->
<template>
  <div
    :style="styleVariables"
    class="canvasitem container"
    v-bind:class="{ select: isSelect() }"
    v-on:keydown.left="keydownAction(0)"
    v-on:keydown.right="keydownAction(1)"
    v-on:keydown.up="keydownAction(2)"
    v-on:keydown.down="keydownAction(3)"
    v-on:mousemove.stop="mousemove"
    v-on:mouseup.stop="mouseup"
    v-on:mouseleave.stop="mouseup"
    v-on:mousedown.stop="mousedown"
    v-on:click.stop="clickAction"
    tabindex="0"
    style="outline: none"
  >
    <div
      class="row justify-content-between"
      style="height: 10px; min-height: 10px; max-height: 10px"
    >
      <!-- <div
        class="col-2 leftup"
        v-on:mousemove.stop="sizeMousemove($event, 2)"
        v-on:mousedown.stop="sizeMousedown($event, 2)"
      ></div>
      <div
        class="col-2 rightup"
        v-on:mousemove.stop="sizeMousemove($event, 3)"
        v-on:mousedown.stop="sizeMousedown($event, 3)"
      ></div> -->
    </div>
    <div class="row">
      <img
        v-bind:src="this.getImagePath()"
        :style="styleVariables"
        class="p-0 m-0 mx-auto canvasimg"
      />
    </div>
    <div
      class="row justify-content-between"
      style="height: 10px; min-height: 10px; max-height: 10px"
    >
      <!-- <div
        class="col-2 leftdown"
        v-on:mousemove.stop="sizeMousemove($event, 4)"
        v-on:mousedown.stop="sizeMousedown($event, 4)"
      ></div>
      <div
        class="col-2 rightdown"
        v-on:mousemove.stop="sizeMousemove($event, 1)"
        v-on:mousedown.stop="sizeMousedown($event, 1)"
      ></div> -->
    </div>
    <div
      :style="styleVariables"
      class="drag"
      v-on:mousemove.stop="mousemove"
      v-on:mouseup.stop="mouseup"
      v-on:mouseleave.stop="mouseup"
      v-if="this.isDrag"
    ></div>
    <div
      :style="styleVariables"
      class="drag"
      v-on:mousemove.stop="sizeMousemove($event, 2)"
      v-on:mouseup.stop="sizeMouseup($event, 2)"
      v-on:mouseleave.stop="sizeMouseup($event, 2)"
      v-on:mousedown.stop="sizeMousedown($event, 2)"
      v-if="this.isSizechangeLeftUp"
    ></div>
    <div
      :style="styleVariables"
      class="drag"
      v-on:mousemove.stop="sizeMousemove($event, 3)"
      v-on:mouseup.stop="sizeMouseup($event, 3)"
      v-on:mouseleave.stop="sizeMouseup($event, 3)"
      v-on:mousedown.stop="sizeMousedown($event, 3)"
      v-if="this.isSizechangeRightUp"
    ></div>
    <div
      :style="styleVariables"
      class="drag"
      v-on:mousemove.stop="sizeMousemove($event, 1)"
      v-on:mouseup.stop="sizeMouseup($event, 1)"
      v-on:mouseleave.stop="sizeMouseup($event, 1)"
      v-on:mousedown.stop="sizeMousedown($event, 1)"
      v-if="this.isSizechangeRightDown"
    ></div>
    <div
      :style="styleVariables"
      class="drag"
      v-on:mousemove.stop="sizeMousemove($event, 4)"
      v-on:mouseup.stop="sizeMouseup($event, 4)"
      v-on:mouseleave.stop="sizeMouseup($event, 4)"
      v-on:mousedown.stop="sizeMousedown($event, 4)"
      v-if="this.isSizechangeLeftDown"
    ></div>
  </div>
</template>

<script>
import Vue from "vue";
import { ToolButtonType } from "@/js/common.js";
import { Rotate, Dot, Normalize } from "@/js/MathVector.js";

export default {
  name: "CanvasItem",
  props: ["itemData"],
  data() {
    return {
      firxtPosX: 0,
      firxtPosY: 0,
      firstItemWidth: 0,
      firstItemHeight: 0,
      firstItemPosX: 0,
      firstItemPosY: 0,
      isTouch: false,
      isSizeTouch: false,
      isDrag: false,
      isSizechangeLeftUp: false,
      isSizechangeRightUp: false,
      isSizechangeLeftDown: false,
      isSizechangeRightDown: false,
    };
  },
  created: function () {
    // サイズを調整
  },
  methods: {
    removeAction: function () {},
    click() {
      Vue.set(this.itemData, "posX", this.itemData.posX + 10);
    },
    getImagePath() {
      //console.log(this.itemData.getImagePath())
      return this.itemData.getImagePath();
    },
    keydownAction(type) {
      if (!this.isSelect()) {
        return;
      }
      switch (type) {
        case 0: // 左
          this.$store.state.currentCanvasData.currentItem.posX -= 1;
          break;
        case 1: // 右
          this.$store.state.currentCanvasData.currentItem.posX += 1;
          break;
        case 2: // 上
          this.$store.state.currentCanvasData.currentItem.posY -= 1;
          break;
        case 3: // 下
          this.$store.state.currentCanvasData.currentItem.posY += 1;
          break;
      }
      this.$store.state.currentCanvasData.currentItem.normalizePosition();
    },
    mousedown(event) {
      if (this.itemData.isTagImage) {
        return;
      }
      if (this.$store.state.currentToolItem == ToolButtonType.select) {
        this.isTouch = true;
        this.firxtPosX = event.pageX;
        this.firxtPosY = event.pageY;
        this.$store.state.currentCanvasData.setCurrentItem(this.itemData);
        this.isDrag = true;
      }
      if (this.$store.state.currentToolItem == ToolButtonType.remove) {
        this.$store.commit("removeCurrentProductCanvasItem", this.itemData);
      }
    },
    mousemove(event) {
      if (this.itemData.isTagImage) {
        return;
      }

      if (!this.isTouch) return;

      let moveX = event.pageX - this.firxtPosX;
      let moveY = event.pageY - this.firxtPosY;
      this.itemData.posX += moveX;
      this.itemData.posY += moveY;
      this.itemData.normalizePosition();
      this.firxtPosX = event.pageX;
      this.firxtPosY = event.pageY;
    },
    mouseup() {
      if (this.itemData.isTagImage) {
        return;
      }

      this.isTouch = false;
      this.isDrag = false;
    },
    sizeMousedown(event, type) {
      if (
        this.$store.state.currentCanvasData.currentItem != null &&
        this.$store.state.currentToolItem == ToolButtonType.select
      ) {
        this.isSizeTouch = true;
        this.firxtPosX = event.pageX;
        this.firxtPosY = event.pageY;
        this.firstWidth = this.itemData.imageWidth;
        this.firstHeight = this.itemData.imageHeight;
        this.firstItemPosX = this.itemData.posX;
        this.firstItemPosY = this.itemData.posY;

        this.isSizechangeLeftUp = false;
        this.isSizechangeLeftDown = false;
        this.isSizechangeRightUp = false;
        this.isSizechangeRightDown = false;
        switch (type) {
          case 1:
            this.isSizechangeRightDown = true;
            break;
          case 2:
            this.isSizechangeLeftUp = true;
            break;
          case 3:
            this.isSizechangeRightUp = true;
            break;
          case 4:
            this.isSizechangeLeftDown = true;
            break;
        }
      }
    },
    sizeMousemove(event, type) {
      if (!this.isSizeTouch) return;

      if( event.movementX == 0 && event.movementY == 0 ) return;
      //console.log(type);

      // 1.右下
      // 2.左上
      // 3.右上
      // 4.左下
      // 座標の定義
      const points = [
        {x:this.itemData.imageWidth/2, y:this.itemData.imageHeight/2},
        {x:-this.itemData.imageWidth/2, y:-this.itemData.imageHeight/2},
        {x:this.itemData.imageWidth/2, y:-this.itemData.imageHeight/2},
        {x:-this.itemData.imageWidth/2, y:this.itemData.imageHeight/2},
      ];

      // 頂点を回転させる
      for( let i=0; i<4; ++i ){
        points[i] = Rotate(points[i], this.itemData.rotate);
      }

      // マウスの移動量をベクトルに変換
      let vec = {x:event.movementX, y:event.movementY }
      let dot = Dot( Normalize(points[type-1]), Normalize(vec) );

      this.itemData.scale += dot*0.2;
      this.itemData.normalizePosition();
    },
    sizeMouseup() {
      this.isSizeTouch = false;
      this.isSizechangeLeftUp = false;
      this.isSizechangeLeftDown = false;
      this.isSizechangeRightUp = false;
      this.isSizechangeRightDown = false;
    },
    clickAction() {},
    isSelect: function () {
      if (!this.$store.state.currentCanvasData) {
        return false;
      }
      return this.$store.state.currentCanvasData.currentItem == this.itemData;
    },
  },
  computed: {
    /**
     * このコンポーネント中で用いるCSS変数をまとめる.
     * @return {object}
     */
    styleVariables() {
      let data = {
        "--item-width": "" + this.itemData.imageWidth * this.itemData.scale + "px",
        "--item-height": "" + this.itemData.imageHeight * this.itemData.scale + "px",
        "--item-div-width":
          "" + (this.itemData.imageWidth * this.itemData.scale + 20) + "px",
        "--item-div-height":
          "" + (this.itemData.imageHeight * this.itemData.scale + 20) + "px",
        "--item-rotate": this.itemData.rotate + "deg",
        // "--item-pos-x": "" + this.itemData.posX - 10 - (this.itemData.imageWidth * this.itemData.scale) / 2 + "px",
        // "--item-pos-y": "" + this.itemData.posY - 10 -  (this.itemData.imageHeight * this.itemData.scale) / 2 + "px",
        "--drag-width":
          "" + (this.itemData.imageWidth * this.itemData.scale + 200) + "px",
        "--drag-height":
          "" + (this.itemData.imageHeight * this.itemData.scale + 200) + "px",
      };

      switch(this.itemData.align){
        case "left":
          data["--item-pos-x"] = "" + this.itemData.posX - 10 + "px";
          data["--item-pos-y"] = "" + this.itemData.posY - 10 -  (this.itemData.imageHeight * this.itemData.scale) / 2 + "px";
          data["--item-origin"] = "" + 10 + "px " + (this.itemData.imageHeight * this.itemData.scale + 20)/2 + "px";
          break;
        case "center":
          data["--item-pos-x"] = "" + this.itemData.posX - 10 - (this.itemData.imageWidth * this.itemData.scale) / 2 + "px";
          data["--item-pos-y"] = "" + this.itemData.posY - 10 -  (this.itemData.imageHeight * this.itemData.scale) / 2 + "px";
          data["--item-origin"] = "";
          break;
        case "right":
          data["--item-pos-x"] = "" + this.itemData.posX - 10 - (this.itemData.imageWidth * this.itemData.scale) + "px";
          data["--item-pos-y"] = "" + this.itemData.posY - 10 -  (this.itemData.imageHeight * this.itemData.scale) / 2 + "px";
          data["--item-origin"] = "" + (this.itemData.imageWidth * this.itemData.scale + 10) + "px " + (this.itemData.imageHeight * this.itemData.scale + 20)/2 + "px";
          break;
      }

       console.log(data)
      return data;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.downbar {
  height: 10%;
  flex: 1;
  display: flex;
}
.leftup,
.leftdown {
  width: 10%;
}
.rightup,
.rightdown {
  width: 10%;
  margin-left: auto;
}
.select .rightdown:hover {
  cursor: nwse-resize;
}
.select .leftdown:hover {
  cursor: nesw-resize;
}
.select .leftup:hover {
  cursor: nwse-resize;
}
.select .rightup:hover {
  cursor: nesw-resize;
}
.canvasitem {
  position: absolute;
  left: var(--item-pos-x);
  top: var(--item-pos-y);
  width: var(--item-div-width);
  min-width: var(--item-div-width);
  max-width: var(--item-div-width);
  height: var(--item-div-height);
  min-height: var(--item-div-height);
  max-height: var(--item-div-height);
  transform: rotate(var(--item-rotate));
  transform-origin: var(--item-origin);
  display: flex;
  flex-direction: column;
}
.canvasimg {
  width: var(--item-width);
  min-width: var(--item-width);
  max-width: var(--item-width);
  height: var(--item-height);
  min-height: var(--item-height);
  max-height: var(--item-height);
}
.select {
  background-color: rgba(243, 126, 126, 0.5);
}
.canvasitem img {
  flex: 1;
  height: 80%;
  object-fit: contain;
  pointer-events: none;
}
.drag {
  z-index: 10000;
  position: absolute;
  top: -100px;
  left: -100px;
  width: var(--drag-width);
  height: var(--drag-height);
  background-color: transparent;
}
</style>
